<template>
  <div class="drapper-container">
    <a-upload-dragger
      v-model:file-list="fileList"
      name="file"
      :multiple="false"
      :before-upload="beforeUpload"
      :custom-request="customRequest"
      :show-upload-list="false"
      accept=".xls,.xlsx"
      class="upload-area"
    >
      <p class="ant-upload-drag-icon">
        <cloud-upload-outlined style="color: #4372fc" class="theme-color" />
      </p>
      <p class="ant-upload-text">点击或拖动文件到虚线框内上传</p>
      <p class="ant-upload-hint">支持xls,xlsx类型的文件</p>
    </a-upload-dragger>
    <div class="loading-container" v-if="calcLoading">
      <a-spin />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "UploadArea",
});
</script>

<script lang="ts" setup>
import { ref } from "vue";
import { CloudUploadOutlined } from "@ant-design/icons-vue";
import { FileRecord } from "@/core/services/file-upload.interface";
import { FileUploadService } from "@/core";
import { getFileExt } from "@/utils";
import { message } from "ant-design-vue";

const props = defineProps({
  calcLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["getFileUrl", "update:calcLoading"]);

const beforeUpload = (file) => {
  if (file.size > 10 * 1024 * 1024) {
    message.warning(`单个文件不得超过10M`);
    return false;
  }
};

const fileList = ref([]);

const customRequest = async ({ file }) => {
  emit("update:calcLoading", true);
  const url = await FileUploadService.uploadToOss(file).catch(() =>
    emit("update:calcLoading", false)
  );
  const fileRecord = new FileRecord();
  fileRecord.merge({
    uid: file.uid,
    name: file.name,
    suffix: getFileExt(file.name),
    size: file.size,
    url,
  });
  emit("getFileUrl", url);
};
</script>

<style lang="less" scoped>
.drapper-container {
  position: relative;
  .loading-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.15);
  }
}
:deep(.upload-area) {
  .ant-upload {
    padding: 40px 0 20px !important;
  }
}
</style>
